export enum TriggerType {
  Load = 'load',
  Click = 'click',
}
